export const rem = (px) => `${px / 16}rem`;

export const flex = (direction, justify, align) => `
  align-items: ${align};
  display: flex;
  flex-direction: ${direction};
  justify-content: ${justify};
`;

export const position = (value, top, right, bottom, left) => `
  position: ${value};
  top: ${top};
  right: ${right};
  bottom: ${bottom};
  left: ${left};
`;

export const gradient = (color1, color2) => `
  background: ${color1};
  background: -moz-linear-gradient(-45deg,  ${color1} 0%, ${color2} 100%);
  background: -webkit-linear-gradient(-45deg,  ${color1} 0%,${color2} 100%);
  background: linear-gradient(135deg,  ${color1} 0%,${color2} 100%);
  filter:
    progid:DXImageTransform.Microsoft.gradient( startColorstr='${color1}', endColorstr='${color2}',GradientType=1 );
`;
